export function Stack({ row }) {
  const quizz = row;

  const bigBlinds = Math.floor(quizz.stack_chips / quizz.blind_big);
  let result = '';

  if(quizz.type === 'cash'){
    result += '$';
  }

  result += new Intl.NumberFormat().format(quizz.stack_chips);

  if(quizz.blind_big > 0 && quizz.stack_chips > 0){
    result += ` ${bigBlinds}BBs`;
  }

  return result;
}
